import { gql } from '@apollo/client';
import { mutate, query } from '../apollo/ApolloClient';

interface Channel {
  id: number;
  name: string;
  type: string;
  emails: string[];
  orgId: number;
}

interface QueryChannelsResponse {
  channels: Channel[];
}

interface UpdateChannelResponse {
  updateChannel: Channel;
}

export interface UpdateChannelRequest {
  id: number;
  name: string;
  type: string;
  emails: string[];
}

const CHANNELS_QUERY = gql`
  query channels {
    channels {
      id
      name
      type
      emails
      orgId
    }
  }
`;

const UPDATE_CHANNEL_MUTATION = gql`
  mutation updateChannel($id: Int32!, $name: String!, $type: ChannelType!, $emails: [String!]!) {
    updateChannel(id: $id, name: $name, type: $type, emails: $emails) {
      id
      name
      type
      orgId
      emails
    }
  }
`;

export const queryChannels = async (): Promise<QueryChannelsResponse | null | undefined> => {
  const data = await query<QueryChannelsResponse>({
    query: CHANNELS_QUERY,
    fetchPolicy: 'network-only',
  });
  return data;
};

export const updateChannel = async (
  updateChannelRequest: UpdateChannelRequest
): Promise<UpdateChannelResponse | null | undefined> => {
  const data = await mutate<UpdateChannelResponse, UpdateChannelRequest>({
    mutation: UPDATE_CHANNEL_MUTATION,
    variables: updateChannelRequest,
  });
  return data;
};
